import { Box, Button, Divider, ImageListItem, Stack, Typography } from '@mui/material';
import { Container } from '@mui/system';
import * as React from 'react';
import { BodyContainer } from '../../containers/BodyContainer';
import { LoginForm } from './LoginForm';
import { customStyles } from '../../../styles';
import styled from '@emotion/styled';
import globalImage from '../../../assets/images/logo.png'
import { MainButton, RegularText, SmallText, Title, UnderlineText } from '../../helpers';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../../../assets/images/logo.png'
import { useNavigate } from 'react-router-dom';
import { getApiKey } from '../../../actions/ApiKeyAction';
import GoogleLogin, { GoogleLogout, useGoogleLogout } from 'react-google-login';
import {gapi} from 'gapi-script'
import { useState } from 'react';
import ReactFacebookLogin from 'react-facebook-login';
import { loginAction } from '../../../actions';
import { setTologOrRegister } from '../../../slices/LoginSlice';

const style = {
  width: 150,
  height: 150,
  borderRadius: 5,
  textAlign: 'center',
  border: 'none',

}

export const Login = () => {
  const { user } = useSelector(state => state.login)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [googleToken, setGoogleToken] = useState(null)
  const [authAccess, setAuthAccess] = useState(null)
  const clientId = process.env.REACT_APP_GOOGLE_AUTH
  // const { profileObj } = googleLogin && googleLogin
  const clientId_f = process.env.REACT_APP_FACEBOOK_LOGIN

  const handleNavigate = () => {
    navigate('/register')
  }
  
  const startGoogle = () => {
    gapi.auth2.init({
      clientId: clientId
    })
  }
  const onSuccess = (resp) => {
    setAuthAccess(resp)
    setGoogleToken(gapi.auth.getToken().access_token)
  }

  const facebookLogin = (resp) => {
    const { userID, email, graphDomain } = resp
    const form = {
      phone: email,
      key: userID,
      method: graphDomain
    }
    dispatch(loginAction(form))
  }
  const logout = () => {
    setAuthAccess(null)
    setGoogleToken(null)
    console.log('logout successful')
  }
  const onFailure = () => {
    console.log("fail connection")
  }
  useEffect(() => {
    gapi.load("client:auth2", startGoogle)
    dispatch(getApiKey())
    dispatch(setTologOrRegister(true))
  }, [])

  
  return (
    <BodyContainer title="" sx={{ height: '80vh', }}>
      <figure style={{ display: 'flex', justifyContent: 'start', marginBottom: 30 }}>
        <img src={logo} alt="global gas" style={{
          width: '200px'
        }}/>
      <Divider />
      </figure>
        <Title text="Inicia sesión" color={customStyles.colors.main}/>
      <Typography mb={1} variant="caption" component="p">Teléfono, correo electrónico o código de invitación:</Typography>
      <LoginForm />
      <UnderlineText text="¿Aún no tienes cuenta? Regístrate" cursor color={customStyles.colors.main} onClick={handleNavigate}/>
      {/* <Divider /> */}

      {/* IMPLEMENT IN THE FUTURE */}

      
      {/* <Box sx={{width: '100%', border: `1px solid ${customStyles.colors.textColor}`, marginTop: 3, opacity: .4}}></Box>
      <RegularText text="O inicia sesión con" color={customStyles.colors.main} sx={{margin: '20px 0'}}/>
      <Stack spacing={3} justifyContent="space-between" alignItems="center" direction="row">
        <GoogleLogin 
          clientId={clientId}
          onSuccess={onSuccess}
          onFailure={onFailure}
          cookiePolicy={"single_host_policy"}
          buttonText="Google"
          className='social-login google--bg'
          icon={false}
          // render={() => ( <MainButton text="Google" onSuccess={onSuccess}/> )}
        />
        <ReactFacebookLogin
          appId={clientId_f}
          autoLoad={false}
          fields="name,email,picture"
          textButton='Facebook'
          language="es_MX"
          // cssClass={(a) => return }
          // onClick={LoginFacebook}
          callback={facebookLogin} 
          cssClass="social-login facebook--bg"
        />
      </Stack> */}
    </BodyContainer>
  );
}
